import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sample-request-inventory-usage-report',
  templateUrl: './sample-request-inventory-usage-report.component.html',
  styleUrls: ['./sample-request-inventory-usage-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SampleRequestInventoryUsageReportComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  redirectToSampleRequestAdminPage() {
    this.router.navigate(['sample-request-admin/home']);
  }

}
